import { createContext, useContext } from 'react'

export enum FeatureContextKeys {
  feature_static_pages,
}

export type FeatureContextFeatures = {
  [key in keyof typeof FeatureContextKeys]?: boolean
}

export type FeatureContextFeatureKeys = keyof FeatureContextFeatures

export const DefaultFeatures: FeatureContextFeatures = {
  feature_static_pages: false,
}

const featureContext = createContext<FeatureContextFeatures>(DefaultFeatures)

export const useFeatureContext = () => useContext(featureContext)

export default featureContext
